import { render, staticRenderFns } from "./thread-training-page.vue?vue&type=template&id=ec388dd2&scoped=true&"
import script from "./thread-training-page.vue?vue&type=script&lang=js&"
export * from "./thread-training-page.vue?vue&type=script&lang=js&"
import style0 from "./thread-training-page.vue?vue&type=style&index=0&id=ec388dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec388dd2",
  null
  
)

component.options.__file = "thread-training-page.vue"
export default component.exports